import React from "react";
import { Container, Overline } from "@/components/common";

export default function PageHero({ label, title, intro, image }) {
  return (
    <section className="relative overflow-hidden bg-navy pb-16 pt-36 md:pb-20 md:pt-44">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/85 to-navy/60" />
        </div>
      )}
      <Container className="relative">
        {label && <Overline className="text-gold">{label}</Overline>}
        <h1 className="mt-4 max-w-4xl font-serif text-4xl tracking-tight text-white md:text-6xl">{title}</h1>
        {intro && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300">{intro}</p>}
      </Container>
    </section>
  );
}
